<template>
  <div id="pay" class="container" style="padding-top:40px;">
    <div class="row">
      <el-row :gutter="40">
        <el-col :span="2" class="icon">
          <i class="far fa-check-circle fa-5x"></i>
        </el-col>
        <el-col :span="17">
          <div class="text1">订单提交成功！请尽快完成支付。</div>
          <div class="text2">
            请在
            <span class="text3">2小时</span> 内完成支付，超时后将取消订单
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="row2">
      <div class="title underline2">选择以下支付方式付款</div>
      <div class="underline">
        <div>
          <el-radio-group v-model="payType">
            <el-radio label="3">银行卡支付</el-radio>

            <el-radio label="1" style="margin-left:30px">支付宝</el-radio>
            <el-radio label="2" style="margin-left:55px">微信支付</el-radio>
          </el-radio-group>
        </div>

        <div class="pay_pic" @click="pci_goToPay(3)">
          <img :src="serve + '/images/pay2.jpg'" />
        </div>
        <div class="pay_pic" @click="pci_goToPay(1)">
          <img :src="serve + '/images/pay3.jpg'" />
        </div>
        <div class="pay_pic" @click="pci_goToPay(2)">
          <img :src="serve + '/images/pay1.jpg'" />
        </div>
      </div>

      <div class="underline" v-if="b_status==1">
        <div style="height:48px;line-height: 48px;">
          <el-col :span="4">
            <el-radio-group v-model="payType">
              <el-radio label="0" @change="balanceAlipay">预付款扣除</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="5">可用余额{{balance}}元</el-col>
        </div>
        <div class="pwd-box" v-show="pass_ipt">
          <el-input
            placeholder="请输入六位支付密码"
            v-model="vip_pwd"
            ref="vip_ipt"
            style="width:200px"
            type="password"
            maxlength="6"
            show-word-limit
          ></el-input>
          <!-- <input
            type="number"
            maxlength="6"
            class="pwd-input"
            id="pwd_input"
            ref="pwd_input"
            autofocus
          />
          <div class="fake-box">
            <input type="password" ref="pwd_inputss" v-model="psword1" readonly />
            <input type="password" v-model="psword2" readonly />
            <input type="password" v-model="psword3" readonly />
            <input type="password" v-model="psword4" readonly />
            <input type="password" v-model="psword5" readonly />
            <input type="password" v-model="psword6" readonly />
          </div>-->
        </div>
      </div>
      <div class="underline" v-if="b_status==0">
        <el-row>
          <el-col :span="4">
            <el-radio-group v-model="payType">
              <el-radio label="0" disabled>预付款扣除</el-radio>
            </el-radio-group>

            <br />
          </el-col>
          <el-col :span="6">
            <div>
              <span>未开通预付款，开通更优惠。</span>
              <span>
                <router-link to="/user/bargain/2" tag="el-link">立即开通</router-link>
                <!-- @click="openDialog=true" -->
              </span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="padding:20px 0 ">
        应付总金额 :
        <span
          style="color:#e2211c;font-size: 20px;
    font-weight: bold;"
        >&yen;{{all_money}}</span> 元
      </div>
      <div>
        <el-button type="primary" class="submit" @click="goToPay()" :loading="loading">立即付款</el-button>
      </div>
    </div>

    <el-dialog title="设置支付密码" :visible.sync="openDialog" width="400px">
      <div style="padding: 0 30px;">
        <div>
          <div style="margin-bottom:10px;">已绑定的手机号：{{bind_mobile}}</div>
          <div style="margin-bottom:20px;">
            <el-input placeholder="请输入内容" v-model="smsCode" autocomplete="off">
              <template slot="append">
                <el-button @click="getSMS" :disabled="smsDis">{{text1}}</el-button>
              </template>
            </el-input>
          </div>
          <div class="lv3Text" style="margin-bottom:10px;">支付密码必须为6位数字</div>
          <el-alert
            :title="error"
            type="error"
            show-icon
            style="margin-bottom:10px;"
            v-if="error.length>0"
            @close="close"
          ></el-alert>
          <div style="margin-bottom:20px;">
            <el-input
              autocomplete="off"
              placeholder="请输入密码"
              v-model="newPW1"
              show-password
              maxlength="6"
            ></el-input>
          </div>
          <div style="margin-bottom:20px;">
            <el-input
              autocomplete="off"
              placeholder="重新确认密码"
              v-model="newPW2"
              show-password
              maxlength="6"
            ></el-input>
          </div>
        </div>
        <div slot="footer" class="dialog-footer" align="right">
          <el-button @click="openDialog = false">取 消</el-button>
          <el-button type="primary" @click="submitPW">确 定</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="储蓄卡支付" :visible.sync="bankDialog" width="30%" center>
      <div>
        <div class="lv3Text s1">宝枫林平台账号：</div>
        <div class="lv2Text s2">31050173380000001102</div>
        <div class="lv3Text s1">银行开户行：</div>
        <div class="lv2Text s2">建设银行上海肇嘉浜路支行</div>
        <div class="lv3Text s1">公司名称:</div>
        <div class="lv2Text s2">业立生物科技（上海）股份有限公司</div>
        <div class="lv3Text s1">税号：</div>
        <div class="lv2Text s2">91310104MA1FR4Y90W</div>
        <div class="lv3Text s3">如您已转账成功，请及时联系宝枫林平台工作人员：</div>
        <div style="margin-bottom:5px;">电话：021-64179406/400-821-3401</div>
        <div>QQ:1093249151</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bankDialog = false" round style="width:100%">已了解</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      all_money: 0,
      vip_pwd: "",
      serve: this.$store.state.serve,
      pass_ipt: false,
      psword1: null,
      psword2: null,
      psword3: null,
      psword4: null,
      psword5: null,
      psword6: null,
      psword7: null,
      bankDialog: false,
      smsCode: "",
      text1: "获取短信",
      newPW1: "",
      newPW2: "",
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      payType: null,
      id: this.$route.query.order,
      ids: this.$route.query.payOrder,
      loading: false,
      balance: 0,
      b_status: null,
      payDialog: false,
      price: 0,
      disabled: true,
      openDialog: false,
      bind_mobile: "",
      smsDis: false,
      error: ""
    };
  },
  beforeCreate() {},
  activated() {
    this.initData();
  },
  updated() {},

  mounted() {
    //
  },
  watch: {
    psword1: function(val, old) {
      if (val == "") {
        $("#psword11").focus();
      } else {
        $("#psword22").focus();
      }
    },
    psword2: function(val, old) {
      $("#psword33").focus();
      if (val == "") {
        $("#psword11").focus();
      }
    },
    psword3: function(val, old) {
      $("#psword44").focus();
      if (val == "") {
        $("#psword22").focus();
      }
    },
    psword4: function(val, old) {
      $("#psword55").focus();
      if (val == "") {
        $("#psword33").focus();
      }
    },
    psword5: function(val, old) {
      $("#psword66").focus();
      if (val == "") {
        $("#psword44").focus();
      }
    },
    psword6: function(val, old) {
      if (val == "") {
        $("#psword55").focus();
      }
    }
  },
  methods: {
    balanceAlipay() {
      this.pass_ipt = true;
      // const _this = this;
      // $("#pwd_input").on("input", function() {
      //   // trim(): 去两边空格的方法；
      //   var pwd = $(this)
      //     .val()
      //     .trim();
      //   for (var i = 0; i < pwd.length; i++) {
      //     $(".fake-box input")
      //       .eq(i)
      //       .val(pwd[i]);
      //   }
      //   $(".fake-box input").each(function() {
      //     var index = $(this).index();
      //     if (index >= pwd.length) {
      //       $(this).val("");
      //     }
      //   });
      //   if (pwd.length == 6) {
      //     //执行其他操作
      //     _this.goToPay1(pwd);
      //   }
      // });
    },
    goToPay1(pwd) {
      const formData = new FormData();
      formData.append("mobile", this.mobile);
      formData.append("token", this.token);
      // if (this.id) {
      //   formData.append("orderCode", this.id);
      // } else if (this.ids) {
      //   formData.append("orderCode", this.g_orderCode);

      // }
      var vipUrl = "";
      if (this.id) {
        formData.append("orderCode", this.id);
        vipUrl = "/member/balancePay";
      } else if (this.ids) {
        formData.append("pay_code", this.ids);
        vipUrl = "/member/newBalancePay";
      }

      formData.append("pay_pass", this.vip_pwd);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      //
      this.axios.post(this.serve + vipUrl, formData, config).then(res => {
        if (res.data.status == "success") {
          this.$message({
            type: "success",
            message: "支付完成"
          });
          this.$router.push("/user/orders/1");
        } else if (res.data.status == "error") {
          this.$message.error(res.data.msg);
        }
      });
    },
    close() {
      this.error = "";
    },
    getSMS() {
      this.axios
        .get(this.serve + "/personal/send_pay_pass_note", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              message: "验证码已发送",
              type: "success"
            });
            var t = 59;
            var that = this;
            this.smsDis = true;
            that.text1 = "60秒后重新发送";
            var tm = setInterval(() => {
              that.text1 = t + "秒后重新发送";
              t--;
              if (t < 0) {
                clearInterval(tm);
                that.text1 = "获取短信";
                that.smsDis = false;
              }
            }, 1000);
          }
        });
    },
    submitPW() {
      let param = new FormData();
      param.append("mobile", this.mobile);
      param.append("token", this.token);
      param.append("code", this.smsCode);
      param.append("new_pay", this.newPW1);
      param.append("new_pay1", this.newPW2);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.axios
        .post(this.serve + "/personal/change_pay_password2", param, config)
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.axios
              .get(this.serve + "/personal/has_pay_pass", {
                params: {
                  mobile: this.$cookies.get("user"),
                  token: this.$cookies.get("token")
                }
              })
              .then(res => {
                this.b_status = res.data.data;
              });
            this.openDialog = false;
          } else {
            this.error = res.data.msg;
          }
        });
    },
    initData() {
      if (this.ids) {
        this.axios(this.serve + "/member/getPayInfo", {
          params: {
            pay_code: this.ids,
            mobile: this.mobile,
            token: this.token
          }
        }).then(res => {
          var json = res.data.data;
          var _this = this;
          let all_money = 0;
          for (var i in json) {
            all_money += parseFloat(json[i].pay_money);
            if (json[i].shop_id === "0") {
              this.g_orderCode = json[i].orderCode;
            }
          }
          this.all_money = all_money;
        });
      }

      this.axios
        .get(this.serve + "/personal/get_bind_mobile", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.bind_mobile = res.data.data;
        });

      this.axios
        .get(this.serve + "/personal/has_pay_pass", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.b_status = res.data.data;
          // 1开通
          if (res.data.data == "1") {
            this.payType = "0";
            this.pass_ipt = true;
          }
        });

      this.axios
        .get(this.serve + "/member/my_balance", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.balance = res.data.data;
          if (_.toNumber(this.price) < _.toNumber(this.balance)) {
            this.disabled = false;
          }
        });
      this.axios
        .get(this.serve + "/member/orderDetail", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            orderCode: this.$route.query.order
          }
        })
        .then(res => {
          this.price = res.data.data;
          this.all_money = res.data.data.pay_money;
          if (_.toNumber(this.price) < _.toNumber(this.balance)) {
            this.disabled = false;
          }
        });
    },
    pci_goToPay(type) {
      this.payType = type;
      this.goToPay();
    },
    goToPay() {
      if (this.id) {
        if (this.payType == 2) {
          this.axios
            .get(this.serve + "/member/weChatPay", {
              params: {
                mobile: this.$cookies.get("user"),
                token: this.$cookies.get("token"),
                orderCode: this.id,
                payway: "3"
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.$router.push(
                  "/user/weChatPayQRcode?qr=" +
                    encodeURIComponent(res.data.data) +
                    "&order=" +
                    this.id
                );
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                  offset: 200
                });
              }
            });
        } else if (this.payType == 1) {
          //利用微信支付的返回值 ，判断 支付宝支付 商品是否下架
          this.axios
            .get(this.serve + "/member/weChatPay", {
              params: {
                mobile: this.$cookies.get("user"),
                token: this.$cookies.get("token"),
                orderCode: this.id,
                payway: "3"
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                window.location.href =
                  this.serve +
                  "/member/AliPays?mobile=" +
                  this.mobile +
                  "&token=" +
                  this.token +
                  "&orderCode=" +
                  this.id +
                  "&payway=2";
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                  offset: 200
                });
              }
            });
        } else if (this.payType == 3) {
          this.bankDialog = true;
        } else if (this.payType == 0) {
          this.goToPay1();
        } else if (this.payType == null) {
          this.$message.error("请选择支付方式");
        }
      } else if (this.ids) {
        if (this.payType == 2) {
          this.axios
            .get(this.serve + "/member/weChatNewPay", {
              params: {
                mobile: this.$cookies.get("user"),
                token: this.$cookies.get("token"),
                pay_code: this.ids,
                payway: "3"
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.$router.push(
                  "/user/weChatPayQRcode?qr=" +
                    encodeURIComponent(res.data.data) +
                    "&order=" +
                    "多订单支付"
                );
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                  offset: 200
                });
              }
            });
        } else if (this.payType == 1) {
          //利用微信支付的返回值 ，判断 支付宝支付 商品是否下架
          this.axios
            .get(this.serve + "/member/weChatNewPay", {
              params: {
                mobile: this.$cookies.get("user"),
                token: this.$cookies.get("token"),
                pay_code: this.ids,
                payway: "3"
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                window.location.href =
                  this.serve +
                  "/member/AliNewPays?mobile=" +
                  this.mobile +
                  "&token=" +
                  this.token +
                  "&pay_code=" +
                  this.ids +
                  "&payway=2";
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                  offset: 200
                });
              }
            });
        } else if (this.payType == 3) {
          this.bankDialog = true;
        } else if (this.payType == 0) {
          // this.payDialog = true;
          this.goToPay1();
        } else if (this.payType == null) {
          this.$message.error("请选择支付方式");
        }
      }
    }
  }
};
</script>
<style lang="scss">
#pay {
  /* .pwd-box {
    width: 310px;
    height: 48px;
    position: relative;
    border: 1px solid #9f9fa0;
    border-radius: 3px;
    overflow: hidden;
  } */
  /* .pwd-box input[type="number"] {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: none;
    font-size: 18px;
    opacity: 0;
    z-index: 1;
    outline: none;
  }
  .fake-box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row;
  }
  .fake-box input {
    flex: 1;
    width: 100%;
    height: 100%;
    border: none;
    border-right: 1px solid #e5e5e5;
    text-align: center;
    font-size: 30px;
    float: left;
  }
  .fake-box input:nth-last-child(1) {
    border: none;
  } */
  .s3 {
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .s1 {
    margin-bottom: 10px;
  }
  .s2 {
    border-bottom: 1px solid #ddd;
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
  .text1 {
    font-size: 22px;
    font-weight: bold;
    padding: 10px 0;
  }
  .text2 {
    color: #999;
  }
  .icon svg {
    color: #e2211c;
  }
  .text3 {
    color: #e2211c;
  }
  .submit {
    margin-top: 20px;
    width: 150px;
  }
  .row {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 40px 100px;
    margin-bottom: 40px;
  }

  .row2 {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 40px;
    .underline {
      padding: 20px 0;
    }
    .pay_pic {
      cursor: pointer;
      display: inline-block;
      *display: inline;
      *zoom: 1;
      margin-right: 10px;
    }
  }
  .underline {
    border-bottom: 1px solid #ddd;
  }
  .underline2 {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
  }
  padding-bottom: 40px;
}
</style>